//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStates', {
//        templateUrl: 'views/components/views/oeeStates/oeeStates.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'oeeStatesService', function (stateService, oeeStatesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListOeeStates: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadOeeStates() {
//                vm.model.itemsListOeeStates = await oeeStatesService.listOeeStates();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'oeestateedit':
//                        go({ oeestate_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadOeeStates();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
